// src/components/Header.js
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import branding from '../config/branding';
import './Header.css';

function Header() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-logo">
          <Link to="/" className="logo-link">
            <div className="logo-wrapper">
              <img 
                src="/serventica-logo.svg"
                alt={branding.appName}
                className="logo-img"
              />
              <div className="logo-content">
                <span className="logo-text">{branding.appName}</span>
                <span className="logo-tagline">{branding.tagline.split(',')[0]}</span>
              </div>
            </div>
          </Link>
        </div>
        
        {/* Desktop Navigation */}
        <nav className="header-nav desktop-nav">
          <Link to="/" className={`nav-link ${isActive('/')}`}>
            <span className="nav-icon">✨</span>
            <span>Overview</span>
          </Link>
          <Link to="/features" className={`nav-link ${isActive('/features')}`}>
            <span className="nav-icon">📡</span>
            <span>SMS & Calls</span>
          </Link>
          <Link to="/features" className={`nav-link ${isActive('/features')}`}>
            <span className="nav-icon">🪄</span>
            <span>AI Studio</span>
          </Link>
          <Link to="/pricing" className={`nav-link ${isActive('/pricing')}`}>
            <span className="nav-icon">💳</span>
            <span>₹5 Unlock</span>
          </Link>
          <Link to="/contact" className={`nav-link ${isActive('/contact')}`}>
            <span className="nav-icon">🤝</span>
            <span>Contact Us</span>
          </Link>
          <Link to="/login?returnTo=/dashboard" className="login-btn">
            <span className="nav-icon">🚀</span>
            <span>Launch Dashboard</span>
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        {/* Mobile Navigation */}
        <nav className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile-nav-content">
            <Link to="/" className={`mobile-nav-link ${isActive('/')}`} onClick={toggleMobileMenu}>
              <span className="nav-icon">✨</span>
              <span>Overview</span>
            </Link>
            <Link to="/features" className={`mobile-nav-link ${isActive('/features')}`} onClick={toggleMobileMenu}>
              <span className="nav-icon">📡</span>
              <span>SMS & Calls</span>
            </Link>
            <Link to="/features" className={`mobile-nav-link ${isActive('/features')}`} onClick={toggleMobileMenu}>
              <span className="nav-icon">🪄</span>
              <span>AI Studio</span>
            </Link>
            <Link to="/pricing" className={`mobile-nav-link ${isActive('/pricing')}`} onClick={toggleMobileMenu}>
              <span className="nav-icon">💳</span>
              <span>₹5 Unlock</span>
            </Link>
            <Link to="/contact" className={`mobile-nav-link ${isActive('/contact')}`} onClick={toggleMobileMenu}>
              <span className="nav-icon">🤝</span>
              <span>Contact Us</span>
            </Link>
            <Link to="/login?returnTo=/dashboard" className="mobile-login-btn" onClick={toggleMobileMenu}>
              <span className="nav-icon">🚀</span>
              <span>Launch Dashboard</span>
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
